import React, { useState } from "react";
import logo from './assets/Elumo Logo Rund.png';
import oss from './assets/Oss.jpg';
import oystein from './assets/Oystein.jpg';
import natalia from './assets/Natalia.jpg';
import instagramIcon from './assets/instagram.png';
import facebookIcon from './assets/facebook.png';
import foredragoystein from './assets/ForedragOystein.jpg';
import familieterapi from './assets/Familieterapi.jpg';
import coaching from './assets/Coaching.jpg';
import helsesamling from './assets/Helsesamling.JPG';
import samtaleterapi from './assets/Samtaleterapi.JPG';
import personvern from './assets/Personvern.JPG';
import personligtrening from './assets/Personlig trening.JPG'
import ft from './assets/FT.JPG';
import kristen from './assets/Kristen.jpg';
import parterapiekte from './assets/parterapi.jpg';
import coachingekte from './assets/Coachingekte.jpg';
import kontaktoss from './assets/Kontaktoss.jpg';
import håp from './assets/Håp.JPG';
import './App.css';
import tistLogo from "./assets/TIST Certified Logo.png";

export default function App() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [status, setStatus] = useState(null);

  function handleChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
  }

  function handleSubmit(e) {
    e.preventDefault();
    if (!form.name.trim() || !form.email.trim() || !form.message.trim()) {
      setStatus({ type: "error", text: "Fyll ut alle feltene før du sender." });
      return;
    }
    setTimeout(() => {
      setStatus({ type: "success", text: "Takk! Meldingen din er sendt." });
      setForm({ name: "", email: "", message: "" });
    }, 700);
  }

  return (
    <>

<div className="App" id="top">
  {/* Header */}
  <header className="App-header">
    <img src={logo} alt="Elumo logo" className="logo-small" />
          <h1 className="site-title">
          <span className="brand">Elumo </span>
          <span className="tagline">Therapeutic Services</span>
          </h1>
    <p>
      Psychotherapy • Supportive Sessions • Coaching • Counseling • Lectures • Personal training • Health Retreats
    </p>
  </header>


<main className="main-content">
  {/* Om oss */}
  <div className="om-oss-container stylish-om-oss" id="om-oss">
    <div className="om-oss-tekst">
      <h2>About us</h2>
      <p>
        We are Øystein and Natalia Sagmo Sivertsen, a married couple in life
        and colleagues in therapeutic work.
        With different professional backgrounds but shared values and vision,
        we run Elumo Therapeutic Services to offer accessible, affordable,
        and high-quality therapeutic support. <br /> <br />
        Our vision is simple, yet important:
        <li>To create services that promote health, healing, and wholeness.</li>
        <li>To create space to focus on the whole person - mind, body, relationships, and meaning.</li>
        <li>To create time to explore, process, grow, and be strengthened with openness and safety, regardless of starting point.</li>
        <li>To create warm human encounters marked by authenticity, empathy, presence, and professional competence.</li>
      </p>
    </div>
    <img src={oss} alt="About us" className="om-oss-bilde" />
  </div>

{/* Øystein */}
<div className="om-oss-container">
  <div className="om-oss-tekst">
    <h2>Øystein</h2>
    <p>
      Øystein is a psychotherapist with a bachelor's degree in psychology 
      and full certification (Level 3 of 3) in Trauma-Informed 
      Stabilization Treatment (TIST). This advanced training provides 
      specialized expertise in working with trauma and other serious 
      related psychological difficulties. <br /><br />

Øystein has clinical experience providing talk therapy 
for a wide range of mental health difficulties and disorders, 
including complex trauma, anxiety, depression, emotional instability, 
addiction, bipolar disorder, obsessive-compulsive disorder (OCD), 
selective mutism, and suicidal thoughts and behaviors.<br /><br />

Øystein's therapeutic approach is characterized by warmth, respect, 
and genuine understanding. Through his competence and warmth, clients feel 
safe, supported, and helped in understanding and discovering themselves.

    </p>
  </div>
  <img src={oystein} alt="Øystein" className="om-oss-bilde" />
    <div className="tema-wrapper">
    <h3>Languages spoken</h3>

    <div className="tema-grid">
      <div>Norwegian</div>
      <div>English</div>
                <div className="logo-wrapper">
  <img src={tistLogo} alt="Sertifisering" className="logo-liten" />
</div>  
</div>
</div>
</div>

{/* Natalia */}
<div className="om-oss-container">
  <div className="om-oss-tekst">
    <h2>Natalia</h2>
    <p>
      Natalia is a licensed psychologist and certified personal trainer, with broad experience in both
      clinical and preventive work with children, adolescents, adults, and older adults. She has worked
      as a psychologist in the Family Counseling Office in Norway, providing therapy, parental guidance,
      courses, and supportive counseling for individuals, couples, and families. <br /><br />

      She is trained in Trauma-Informed Stabilization Therapy (TIST) for individuals and
      Emotionally Focused Therapy (EFT) for couples and families, which enables her to address a wide
      range of challenges in a safe, competent, and structured manner. <br /><br />

      She has a particular interest in the connection between body and mind, and in how lifestyle,
      relationships, and psychological processes influence health and quality of life.
      With her professional interests in cognitive psychology, health psychology, and
      existential and religious psychology, she approaches clients holistically, with a focus on
      emotional, cognitive, relational, and physical aspects.
    </p>
  </div>
  <img src={natalia} alt="Natalia" className="om-oss-bilde" />
  <div className="tema-wrapper">
    <h3>Languages spoken</h3>

    <div className="tema-grid">
      <div>Norwegian</div>
      <div>English</div>
      <div>Polish</div>
    </div>
</div>
</div>

    
<section id="services" className="section services-table-section">
  <h2>Services and Prices</h2>

  <table className="price-table">
    <thead>
      <tr>
        <th>Service</th>
        <th>Duration</th>
        <th>Price</th>
        <th>Format</th>
      </tr>
    </thead>
    <tbody>
      <tr onClick={() => document.getElementById("tilnærming").scrollIntoView({ behavior: "smooth" })} className="clickable-row">
        <td>Individual Therapy</td>
        <td>60 / 90 min</td>
        <td>700 kr / 950 kr</td>
        <td>Online / in-person</td>
      </tr>
      <tr onClick={() => document.getElementById("støttesamtale").scrollIntoView({ behavior: "smooth" })} className="clickable-row">
        <td>Supportive Sessions</td>
        <td>60 / 90 min</td>
        <td>700 kr / 950 kr</td>
        <td>Online / in-person</td>
      </tr>
      <tr onClick={() => document.getElementById("coaching").scrollIntoView({ behavior: "smooth" })} className="clickable-row">
        <td>Coaching / Counseling</td>
        <td>60 / 90 min</td>
        <td>700 kr / 950 kr</td>
        <td>Online / in-person</td>
      </tr>
      <tr onClick={() => document.getElementById("parterapi").scrollIntoView({ behavior: "smooth" })} className="clickable-row">
        <td>Couples Therapy</td>
        <td>60 / 90 min</td>
        <td>950 kr / 1200 kr</td>
        <td>Online / in-person</td>
      </tr>
      <tr onClick={() => document.getElementById("familieterapi").scrollIntoView({ behavior: "smooth" })} className="clickable-row">
        <td>Family Therapy</td>
        <td>60 / 90 min</td>
        <td>1200 kr / 1450 kr</td>
        <td>Online / in-person</td>
      </tr>
      <tr onClick={() => document.getElementById("personligtrening").scrollIntoView({ behavior: "smooth" })} className="clickable-row">
        <td>Personal Training</td>
        <td>60 min</td>
        <td>700 kr</td>
        <td>Online / in-person</td>
      </tr>
      <tr onClick={() => document.getElementById("kurs-foredrag").scrollIntoView({ behavior: "smooth" })} className="clickable-row">
        <td>Lectures / Courses / Workshops</td>
        <td>—</td>
        <td>Price by agreement</td>
        <td>In-person / online</td>
      </tr>
      <tr onClick={() => document.getElementById("helsesamlinger").scrollIntoView({ behavior: "smooth" })} className="clickable-row">
        <td>Health Retreats</td>
        <td>—</td>
        <td>Price by agreement</td>
        <td>In-person</td>
      </tr>
      <tr onClick={() => document.getElementById("contact").scrollIntoView({ behavior: "smooth" })} className="clickable-row">
        <td>Written Documentation</td>
        <td>30 min</td>
        <td>500 kr</td>
        <td>—</td>
      </tr>
    </tbody>
  </table>

  <p className="service-note">
    <em>
      Our services can be provided at our office in Dokka,<br />
      or at another location by agreement.
    </em>
  </p>
</section>


{/* Tilnærming */}
<div className="om-oss-container" id="tilnærming">

  <div className="om-oss-tekst">
    <h2>Individual Therapy</h2>
    <p>
      This service is for those who seek help with getting more inner peace and control, gaining deeper
      self-understanding, and processing the difficulties they are struggling with.
      The focus is on stabilization, exploration, understanding, regulation, and processing. <br /> <br />

      We are both trained in Trauma-Informed Stabilization Therapy (TIST). TIST is a modern
      integration of several of the most well-established psychotherapeutic approaches,
      such as CBT, MCT sensorimotor psychotherapy, and IFS. This method is particularly well suited
      for working with trauma and other severe psychological challenges at an advanced level,
      while also being applicable to less complex difficulties. <br /><br />

      Through TIST, we focus on restoring inner peace and control in life by activating the brain’s
      control center (the prefrontal cortex). From there, we support you in processing difficult
      thoughts, emotions, and parts of yourself. We can also help with processing traumatic memories, 
      but it is not necessary for effective treatment with TIST. <br /><br />

      When needed, we work integratively and combine TIST with other approaches,
      such as IFS, CBT, MCT, EFT, and sensorimotor psychotherapy. This allows us to tailor
      the treatment to each individual client and provide the best possible support and development.
    </p>
  </div>

  <img
    src={samtaleterapi}
    alt="Individual therapy"
    className="om-oss-bilde"
  />

  {/* Temaer INNI samme boks */}
  <div className="tema-wrapper">
    <h3>Common Focus Areas</h3>

    <div className="tema-grid">
      <div>Complex PTSD</div>
      <div>Trauma</div>
      <div>Obsessive thoughts</div>
      <div>Dissociative disorders</div>
      <div>Depression</div>
      <div>Stress / Anxiety</div>
      <div>Self-harm</div>
      <div>Burnout</div>
      <div>“Good girl syndrome”</div>
      <div>Shame / Self-contempt</div>
      <div>Suicidal thoughts</div>
      <div>Eating disorders</div>
      <div>Emotional instability</div>
      <div>Addiction</div>
      <div>Self-image / Identity</div>
      <div>Attachment style</div>
      <div>ADHD</div>
      <div>Anger</div>
    </div>
  </div>

  <p className="individualterapi-warning">
    ⚠️ We do not offer psychological assessment.
  </p>

</div>

<div className="om-oss-container" id="støttesamtale">
  <div className="om-oss-tekst">
    <h2>Supportive Sessions</h2>
    <p>
      This service is for those who are going through a challenging life situation and need support,
      sorting out thoughts, and relief. The sessions provide space to put into words what feels overwhelming,
      helping to create clarity, calm, and stability during difficult periods. <br /><br />

      The focus is on organizing thoughts and emotions, normalizing reactions, and providing support
      when facing life transitions, burdens, changes, or relational challenges. The sessions can
      serve as a safe pause where you are not required to perform or “solve” anything, but can
      be met with understanding and security. <br /><br />

      The process is tailored to your situation and pace, with the goal of relieving pressure and
      strengthening your ability to cope with what you are experiencing.
    </p>
  </div>
  <img src={coaching} alt="Counseling" className="om-oss-bilde" />

  <div className="tema-wrapper">
    <h3>Common Focus Areas</h3>
    <div className="tema-grid">
      <div>Everyday stress and burdens</div>
      <div>Need to “vent”</div>
      <div>Life crises / Transitions</div>
      <div>Illness</div>
      <div>Grief</div>
      <div>Relational difficulties</div>
      <div>Study / Job changes</div>
      <div>Support for relatives</div>
      <div>Sexuality</div>
      <div>Existential issues</div>
      <div>Emotional overload</div>
    </div>
  </div>
</div>


<div className="om-oss-container" id="coaching">
  <div className="om-oss-tekst">
    <h2>Coaching / Counseling</h2>
    <p>
      This service is for those seeking a sparring partner for goal-oriented awareness, 
      reflection, and personal or relational development. The sessions provide space to explore 
      what shapes your choices, reactions, and relationships, as well as what can provide 
      direction, meaning, and balance in life. <br /><br />

      We work on helping clients to clarify their goals and values, strengthening inner integrity, 
      and offering new perspectives throughout their process. Emphasis is placed on 
      developing reflective abilities, self-awareness, and accountability, so that 
      changes can occur in a solid and lasting manner.
    </p>
  </div>
  <img src={parterapiekte} alt="Coaching / Guidance" className="om-oss-bilde" />

  <div className="tema-wrapper">
    <h3>Common Focus Areas</h3>
    <div className="tema-grid">
      <div>Personal growth / Character building</div>
      <div>Clarifying values</div>
      <div>Relationship guidance</div>
      <div>Partner choice</div>
      <div>Meaning making</div>
      <div>Lifestyle changes</div>
      <div>Stress management</div>
      <div>Spirituality</div>
      <div>Religiosity</div>
      <div>Life decisions</div>
      <div>Anger management</div>
    </div>
  </div>
</div>


<div className="om-oss-container" id="parterapi">
  <div className="om-oss-tekst">
    <h2>Couples Therapy</h2>
    <p>
      Couples therapy is for partners seeking support to understand and strengthen their relationship,
      whether they are facing specific challenges or wish to improve connection and interaction.
      The sessions provide space to explore patterns in communication, emotional closeness, and conflict resolution. <br /><br />

      Natalia has experience with couples therapy from the Family Counseling Office in Norway and works
      with principles from Emotionally Focused Therapy (EFT) for couples and Trauma-Informed Stabilization Treatment (TIST).
      Sessions emphasize understanding both your own and your partner’s reactions, needs, and vulnerabilities,
      helping the couple develop better ways of communicating with each other. <br /><br />

      The process is tailored to the couple’s situation and pace, aiming to strengthen understanding, attachment,
      trust, and collaboration, while laying the foundation for more openness, intimacy, and clarity.
    </p>
  </div>
  <img src={oss} alt="Couples therapy" className="om-oss-bilde" />

  <div className="tema-wrapper">
    <h3>Common Focus Areas</h3>
    <div className="tema-grid">
      <div>Strengthening the relationship</div>
      <div>Communication</div>
      <div>Love languages</div>
      <div>Marriage preparation</div>
      <div>Jealousy</div>
      <div>Emotional closeness</div>
      <div>Physical intimacy</div>
      <div>Conflict resolution</div>
      <div>Infidelity</div>
    </div>
  </div>
</div>


<div className="om-oss-container familieterapi-container" id="familieterapi">
  <div className="om-oss-tekst familieterapi-tekst">
    <h2>Family Therapy</h2>
    <p>
      Family therapy is for families seeking support when facing challenges that 
      affect interaction, safety, and belonging. Sessions provide space to explore 
      communication, relationships, and emotional patterns, with the goal of increasing understanding 
      and improving connection among family members. <br /><br />

      Natalia has experience with family therapy from the Family Counseling Office in Norway and 
      works with an approach that emphasizes understanding, emotional safety, stability, 
      and regulation. The process ensures that all voices are heard at a pace that accommodates both 
      children and adults, fostering new ways of relating to each other. <br /><br />

      The therapy is tailored to the family’s situation and needs, focusing on strengthening bonds, 
      managing conflicts, and creating a safe and collaborative environment.
    </p>
  </div>
  <img src={ft} alt="Family therapy" className="om-oss-bilde familieterapi-bilde" />

  <div className="tema-wrapper">
    <h3>Common Focus Areas</h3>
    <div className="tema-grid">
      <div>Communication</div>
      <div>Family interaction</div>
      <div>Emotional closeness</div>
      <div>Conflict resolution</div>
      <div>Cultural conflicts</div>
      <div>Illness</div>
      <div>Parental guidance</div>
    </div>
  </div>
</div>


<div className="om-oss-container" id="personligtrening">
  <div className="om-oss-tekst">
    <h2>Personal Training</h2>
    <p>
      Personal training is for those who want to strengthen their body, increase energy, find the balance between work and rest, 
      and develop healthy habits that support both physical and mental well-being. 
      The training is tailored to your goals, level, and life situation. <br /><br />

      The coaching sessions and/or training are tailored to your goals,
       fitness level, and personal circumstances. Through focused 
       conversations and/or training sessions, you receive support 
       in gradually strengthening your body, building healthy habits, 
       and becoming more aware of your own health. Everything is adapted 
       to your needs and pace, with a 
      focus on balance, personal growth, motivation, and lasting results.<br /><br />

      Natalia is a certified personal trainer (EQS Level 4) and combines professional knowledge 
      with a holistic approach that considers both body and mind. Through goal-oriented 
      conversations or workout sessions, you receive support to strengthen your body, 
      develop good routines, and increase awareness of your own health. <br /><br />

      Two specialized programs are currently under development. The first one focuses on 
      stress/exhaustion and the other is aligned with the female cycle. <br /><br />
    </p>
  </div>
  <img src={personligtrening} alt="Personal development" className="om-oss-bilde" />

  <div className="tema-wrapper">
    <h3>Common Focus Areas</h3>
    <div className="tema-grid">
      <div>Exercise enjoyment</div>
      <div>Basic strength and endurance</div>
      <div>Muscle building</div>
      <div>Mobility</div>
      <div>Flexibility</div>
      <div>Home workout</div>
      <div>Outdoor workout</div>
      <div>Stress-friendly training</div>
      <div>Lifestyle changes</div>
      <div>Balance between activity and rest</div>
      <div>Restituion</div>
    </div>
  </div>
</div>

{/* Lectures, Courses, and Workshops */}
<div className="om-oss-container" id="kurs-foredrag">
  <div className="om-oss-tekst">
    <h2>Lectures & Workshops</h2>
    <p>
      We offer lectures, courses, workshops, and teaching for children, youth, and adults,
      aimed at enhancing understanding, reflection, and personal/relational development. <br/><br/>

      The content combines theory and practice in an accessible and engaging way,
      covering topics that touch on inner life, relationships, coping, and meaning in daily life.
      Øystein has experience teaching at POFU, leading conflict management courses 
      for Mental Helse, and giving talks at Mental Helse Ungdom Kongsberg. 
      Natalia has experience teaching and giving talks to young people and 
      adults on a range of health-related topics. Together, Natalia and 
      Øystein have spent several 
      years giving talks and leading courses for different groups and schools. <br/><br/>

      The presentation emphasizes openness, recognition, and inspiration, giving participants both
      insights and practical perspectives they can take forward. Content and format are adapted
      to the audience, context, and needs, suitable for schools, workplaces, organizations,
      and other communities.
    </p>
  </div>
  <img src={foredragoystein} alt="Lectures and Workshops" className="om-oss-bilde" />
  
  <div className="tema-wrapper">
    <h3>Common Focus Areas</h3>
    <div className="tema-grid">
      <div>Trauma</div>
      <div>Conflict Management</div>
      <div>Relationships</div>
      <div>Communication</div>
      <div>Addiction</div>
      <div>Social Media</div>
      <div>Burnout</div>
      <div>Shame</div>
      <div>Anxiety</div>
      <div>Depression</div>
      <div>Perfectionism</div>
      <div>Spirituality</div>
      <div>Religiosity</div>
      <div>Symbolism</div>
      <div>Cognitive Psychology</div>
    </div>
  </div>
</div>

{/* Health Retreats */}
<div className="om-oss-container" id="helsesamlinger">
  <div className="om-oss-tekst">
    <h2>Health Retreats</h2>
    <p>
      Health retreats are for those who want to step back from daily life and create space
      for rest, inspiration, and reflection. The retreats take place in peaceful and scenic
      surroundings on a small farm, offering an experience that combines knowledge, presence,
      and calm. <br/><br/>

      Through lectures on various health and personal development topics, conversations,
      gentle movement, and nature immersion, you will have the opportunity to relax, reflect,
      and gather inspiration. Between lectures, flavorful and nourishing meals are served,
      accommodating allergies and other specific needs. <br/><br/>

      Health retreats are suitable for friends, colleagues, couples, families, or small groups
      who want to do something meaningful together, or for individuals who wish to come
      alone and be part of a warm and inclusive community. <br/><br/>

      Follow us on Facebook or Instgram for updates, events and new retreats. It is also possible to design a custom health retreat tailored to your preferences
      and needs.
    </p>
  </div>
  <img src={helsesamling} alt="Health Retreats" className="om-oss-bilde" />
</div>
{/* Option for Christian-sensitive Perspective */}
<div className="om-oss-container" id="kristen">
  <div className="om-oss-tekst">
    <h2>Option for a Christian Perspective</h2>
    <p>
      Many Christians struggling with mental health find that conventional
      mental health care does not always acknowledge or understand their faith life.
      The Christian dimension of life is often an important part of both identity
      and life’s challenges, and when this is not considered in therapy, the overall
      experience can feel incomplete. <br/><br/>

      As Christian practitioners, both Øystein and Natalia have solid experience
      in supporting Christian clients who wish their faith to be a natural part
      of the therapeutic process. <br/><br/>

      Therefore, all our services can be adapted to a Christian understanding,
      without compromising professional standards or methodology. How much faith
      is integrated into the process is entirely up to you, and it is always done
      in a respectful, safe, and non-judgmental manner.
    </p>
  </div>
  <img src={kristen} alt="Christian-sensitive perspective" className="om-oss-bilde" />
</div>

{/* Practical Information and Privacy */}
<div className="om-oss-container familieterapi-container" id="personvern">
  <div className="om-oss-tekst familieterapi-tekst">
    <h2>Practical Information and Privacy Policy</h2>
    <ul>
      <li>Opening hours: Sunday to Thursday 07:00-21:00, Fridays 07:00-15:00 - including holidays.</li>
      <li>Payment happens after the session via bank card or Vipps, directly through SMS on their phone.</li>
      <li>Cancellations and appointment changes must be made at least 24 hours before the appointment, otherwise the full fee applies.</li>
      <li>All clinical documentation and payments are handled securely via Konfidens.no (an encrypted and approved system).</li>
      <li>We maintain confidentiality and comply with GDPR, "helsepersonelloven" and "pasient- og brukerrettighetsloven".</li>
      <li>Since Øystein is a certified psychotherapist and not a psychologist, his therapy is not legally considered health treatment in Norway.</li>
      <li>Many insurance companies and occupational health services cover up to 10 sessions with a psychologist.
        Check with your insurer or employer to see if this applies to you.</li>
      <li>Follow us on social media for updates, events and retreats (see below).</li>
    </ul>
    <p>
      📖 Read more in our documents: 
      <a href="/Information Sheet for Elumo Therapeutic Services.docx.pdf" 
      target="_blank" rel="noopener noreferrer"> Information Sheet</a> and 
      <a href="/Privacy Statement for Elumo Therapeutic Services.docx.pdf" 
      target="_blank" rel="noopener noreferrer"> Privacy Policy</a>
    </p>
  </div>
</div>
{/* Contact */}
<section id="contact" className="section contact">
  <h3>Contact us</h3>

  <div className="contact-container">
    {/* Info box */}
    <div className="contact-info-box">
      <p><strong>Phone</strong></p>
      <p>Øystein: <a className="phone-link" href="tel:+4748178629">+47 481 78 629</a></p>
      <p>Natalia: <a className="phone-link" href="tel:+47498663488">+47 986 63 488</a></p>

      <p><strong>Email</strong></p>
      <p><a className="email-link" href="mailto:elumoterapeutisketjenester@gmail.com">elumoterapeutisketjenester@gmail.com</a></p>

      <div className="follow-us">
        <p><strong>Follow Us</strong></p>
        <div className="social-links">
          <a href="https://www.instagram.com/elumoterapeutisketjenester/?hl=no" target="_blank" rel="noopener noreferrer" className="social-link">
            <img src={instagramIcon} alt="Instagram" />
            <span>Instagram</span>
          </a>
          <a href="https://www.facebook.com/people/Elumo-Terapeutiske-Tjenester/61577333022163/" target="_blank" rel="noopener noreferrer" className="social-link facebook">
            <img src={facebookIcon} alt="Facebook" />
            <span>Facebook</span>
          </a>
        </div>
      </div>
    </div>
                <img src={kontaktoss} alt="Om oss" className="om-oss-bilde" />
  </div>

  <p className="safety-warning">
    &#128680; For urgent help, contact the emergency medical service in your country. <br/>
    ⚠️ Do not share sensitive personal information about yourself or others via SMS or email.
  </p>
</section>

{/* Closing Box */}
<div className="om-oss-container avslutningsboks">
  <div className="om-oss-tekst avslutnings-tekst">
    <h2>We look forward to hearing from you!</h2>
  </div>
  <img
    src={håp}
    alt="We look forward to hearing from you"
    className="om-oss-bilde avslutnings-bilde"
  />
</div>
</main>
<footer className="App-footer">
  <div className="footer-content">
    <p>© {new Date().getFullYear()} Elumo Therapeutic Services</p>
    <p>Health, Healing and Wholeness.</p>
  </div>
</footer>
</div>
</>
);
}
